export default __webpack_public_path__ + "static/media/mainmenu_specification.9a79d7e0.jpg";